import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import Input from '../../../components/forms/Input'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid2 } from '@mui/material'
import { useDispatch } from 'react-redux'
import SimpleTextArea from 'components/forms/SimpleTextArea'
import ToastrAction from 'toastr/actions/ToastrAction'
import HelpAction from 'help/actions/HelpAction'
import ProgressBar from 'components/progress/ProgressBar'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { template } from 'lodash'
import FileSelection from 'components/file/FileSelection'

const STATES = {
    CREATION: 'Creation',
    LOADING: 'Loading',
    RESULT: 'Result',
    ERROR: 'Error',
}

const IssueDialog = ({
    isOpen = false,
    setIsOpen = () => { },
    email,
    user,
    screenshot,
}) => {
    const dispatch = useDispatch()

    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [selectedFiles, setSelectedFiles] = useState([])
    const [idIssue, setIdIssue] = useState(0)
    const [showLink, setShowLink] = useState(false)

    const [stateValue, setStateValue] = useState(STATES.CREATION)


    const resetState = () => {
        setTitle('')
        setDescription('')
        setSelectedFiles([])
    }

    const onSendIssue = async () => {
        if (title === '' || description === '') {
            dispatch(ToastrAction.error(i18n.pleaseRequiredFields))
            return
        }

        setStateValue(STATES.LOADING)

        const base64screen = screenshot.split(',')[1]
        const filename = 'screenshotApp.png'

        const sendScreen = {
            name: filename,
            content: base64screen,
        }

        const files = selectedFiles && selectedFiles.length > 0
            ? [sendScreen, ...selectedFiles]
            : [sendScreen]


        const body = {
            title,
            description,
            files,
            user,
            email,
            location: window.location.href,
        }


        dispatch(HelpAction.createIssue(body)).then(({ success, id, show }) => {
            setShowLink(show)
            if (success) {
                resetState()
            }

            if (id !== 0) {
                setIdIssue(id)
                setStateValue(STATES.RESULT)
            } else {
                setStateValue(STATES.ERROR)
            }
        })
    }

    return (
        <Dialog
            open={isOpen}
            maxWidth='lg'
        >
            <DefaultDialogTitle title={i18n.createSupportTicket} onClose={() => {
                setIsOpen(false)
                setShowLink(false)
                resetState()
                setStateValue(STATES.CREATION)
            }}
            />
            <DialogContent sx={{ width: '100%' }}>
                { stateValue === STATES.CREATION && (
                    <Grid2 size={12} marginBottom={1}>
                        <span style={{ fontStyle: 'italic' }}> {i18n.informationScreenshot} </span>
                    </Grid2>
                )}
                <Card sx={{ width: '100%' }}>
                    <CardContent>
                        {
                            stateValue === STATES.CREATION && (
                                <Grid2 container justifyContent='space-between' spacing={1}>
                                    <Grid2 container size={8} spacing={1}>
                                        <Grid2 size={12}>
                                            <Input
                                                title={i18n.title}
                                                value={title}
                                                onChange={setTitle}
                                                obligatory
                                                maxLength={128}
                                            />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <SimpleTextArea
                                                title={i18n.description}
                                                value={description}
                                                onChange={setDescription}
                                                rows={16}
                                                obligatory
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 container size={4}>
                                        <Grid2 container size={12} sx={{ height: '100%' }}>
                                            <FileSelection files={selectedFiles} setFiles={setSelectedFiles} multiple fileAccept='.pdf, image/*, .xlsx, .xls, .docx, .odt, .csv, .zip'/>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                            )
                        }
                        {
                            stateValue === STATES.LOADING && (
                                <Grid2 size={12}>
                                    <ProgressBar indeterminate={true} withMessage={true} message={i18n.issueCreation}/>
                                </Grid2>
                            )
                        }
                        {
                            stateValue === STATES.RESULT && (
                                <Grid2 container spacing={2} direction={'column'} alignItems='center' justifyContent='center'>
                                    <Grid2 sx={{ textAlign: 'center' }}>
                                        <span>{template(i18n.issueCreated)({ idIssue })}</span>
                                    </Grid2>
                                    { showLink && (
                                        <Grid2>
                                            <Button onClick={ () => window.open(`https://support.aquasys.fr/view.php?id=${idIssue}`, '_blank')}>{i18n.issueAccess}</Button>
                                        </Grid2>
                                    )}
                                </Grid2>
                            )
                        }
                        {
                            stateValue === STATES.ERROR && (
                                <Grid2 container spacing={2} direction={'column'} alignItems='center'>
                                    <Grid2 size={12} sx={{ textAlign: 'center' }}>
                                        <span>{i18n.issueCreateErrorShow}</span>
                                    </Grid2>
                                </Grid2>
                            )
                        }
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                { stateValue === STATES.CREATION ? (
                    <Button
                        onClick={onSendIssue}
                        variant='contained'
                        color='primary'
                    >
                        {i18n.send}
                    </Button>
                ) : (
                    <Button
                        onClick={ () => {
                            setIsOpen(prev => !prev)
                            setShowLink(false)
                            setStateValue(STATES.CREATION)
                        }}
                        variant='contained'
                        color='primary'
                    >
                        {i18n.close}
                    </Button>
                )}

            </DialogActions>
        </Dialog>
    )
}

IssueDialog.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    email: PropTypes.string,
    user: PropTypes.string,
    screenshot: PropTypes.string,
}

export default IssueDialog
